"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _secretManagerService = require("../../../../../services/secret-manager-service");

var _ApprovalModal = _interopRequireDefault(require("../../../../../common-widgets/approval-modal/ApprovalModal"));

var _constants = require("../all-secrets/secret-list/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var SecretApprovalModal = function SecretApprovalModal(_ref) {
  var vaultId = _ref.vaultId,
      selectedItemAncestors = _ref.selectedItemAncestors,
      handleApprovalModal = _ref.handleApprovalModal,
      approversDetails = _ref.approversDetails,
      secretName = _ref.secretName;

  var fetchSecretDetails = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
      var ancestors, payload, secretDetails;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ancestors = _toConsumableArray(selectedItemAncestors);
              ancestors.push({
                label: secretName,
                details: {
                  entityType: 'secret'
                }
              });
              payload = {
                parents: ancestors.slice(1),
                vaultId: vaultId,
                data: values
              };
              _context.next = 5;
              return (0, _secretManagerService.getSecretDetails)(payload);

            case 5:
              secretDetails = _context.sent;
              return _context.abrupt("return", secretDetails);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchSecretDetails(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_ApprovalModal.default, {
    entityName: secretName,
    approversDetails: approversDetails,
    onSubmit: fetchSecretDetails,
    onModalClose: handleApprovalModal,
    action: _constants.translatedStringsForApprovalsModal.viewAction,
    entityType: "secret"
  });
};

SecretApprovalModal.propTypes = {
  vaultId: _propTypes.default.string,
  selectedItemAncestors: _propTypes.default.array,
  secretName: _propTypes.default.string,
  handleApprovalModal: _propTypes.default.func,
  approversDetails: _propTypes.default.object,
  translatedStringsForApprovalsModal: _propTypes.default.object
};
var _default = SecretApprovalModal;
exports.default = _default;